import React,{ useContext } from 'react';
import {
  getSystemSettings
} from "../../../../../functions/Functions"
import { Modal, Button } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { SettingsContext } from '../../../../../contexts/Settings';

const OrderTypeModal = ({
  show,
  setshow,
  orderTypes, 
  availableDeliveryParties,
  setSelected,
  setSelectedSubItem,
  selectedType,
  SelectedSubType
}) => {
  // const [selectedType, setSelectedType] = useState(null);
  // const [SelectedSubType, setSelectedSubType] = useState(null);
  const { order_id } = useParams();
  const { generalSettings } = useContext(SettingsContext)

  const handleSelect = () => {
    if (selectedType) {
      setshow(false);
    }else{
      toast.error("Please select order type");
    }
  };

  // Custom image path mapping
  const getImageByType = (typeName) => {
    switch (typeName.toLowerCase()) {
      case 'dine-in':
        return '/assets/img/din.png';
      case 'delivery':
        return '/assets/img/riderordertype.png';
      case 'takeaway':
        return '/assets/img/takeway.png';
      default:
        return '/assets/img/customer.png';
    }
  };

  const handleCurrentOrderType = (orderType) => {
    if (order_id && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))) return toast.error("Can't change menu on edit complete the current order");
    setSelected(orderType);  // this state for old scenario
    // setSelectedType(orderType);
    // setSelectedSubType(null)
    const party = availableDeliveryParties && availableDeliveryParties[orderType?.id] && availableDeliveryParties[orderType?.id].find(item => item?.name?.toLowerCase() === orderType?.name?.toLowerCase());
    party && setSelectedSubItem(party,orderType,true)
  }
  const handleCurrentOrderType_SubCat = (subitem) => {
    if (order_id && !parseInt(getSystemSettings(generalSettings, "change_odt_edit"))) return toast.error("Can't change menu on edit complete the current order");
    setSelectedSubItem(subitem, selectedType)
    // setSelectedSubType(subitem)
  }

  
  return (
    <Modal show={show} onHide={() => setshow(false)} centered>
      <Modal.Body className="order-modal-body order-type-modal-pos">
        <h5 className="text-center mb-4 mt-0">Select Order Type</h5>

        <div className="order-type-grid">
          {orderTypes && orderTypes.map((type, idx) => (
            <div
              key={idx}
              className={`order-type-box ${selectedType?.name === type?.name ? 'selected' : ''}`}
              onClick={() => handleCurrentOrderType(type)}
            >
              <div className="order-icon">
                <img src={getImageByType(type?.name)} alt={type?.name} style={{ width: '95px', height: '95px' }} />
              </div>
              <div className="order-label">{type.name}</div>
            </div>
          ))}
        </div>
        {selectedType && availableDeliveryParties[selectedType?.id] && (
          <div className={`order-channel-grid mt-3`}>
            {availableDeliveryParties[selectedType?.id].map((party) => (
              <>
                <button className={`channel-btn ${SelectedSubType?.id == party?.id ? "selected":"" } `} onClick={() => handleCurrentOrderType_SubCat(party)} key={party?.id}>{party?.name}</button>
              </>
            ))}
          </div>
        )}

        <Button className="select-btn mt-3" onClick={handleSelect}>Select</Button>
      </Modal.Body>
    </Modal>
  );
};

export default OrderTypeModal;
